import { ScriptableContext } from "chart.js";

import { translate } from "@ascendnow/shared";

import { IAssessmentCategoryProps } from "./AscBaselineAssessmentComparison.type";

export function linearGradient(startColor: string, endColor: string) {
  return function (context: ScriptableContext<"bar">) {
    const chart = context.chart;
    const { ctx, chartArea } = chart;

    if (!chartArea) {
      // This case happens on initial chart load
      return;
    }
    const gradient = ctx.createLinearGradient(
      0,
      chartArea.bottom,
      0,
      chartArea.top
    );
    gradient.addColorStop(0, startColor);
    gradient.addColorStop(1, endColor);
    return gradient;
  };
}

export const baselineAssessmentColor = {
  chart: {
    blue: linearGradient("#61D5EE", "#FFFFFF"),
    violet: linearGradient("#C3B6FD", "#4239fb"),
    gold: linearGradient("#FFE9CF", "#ff9b04"),
  },
  blue: "#61D5EE",
  violet: "#7B60FA",
  gold: "#FEB45E",
};

export function getBaselineAssessmentCategories(
  categories: IAssessmentCategoryProps[]
) {
  if (categories && categories.length > 0) {
    const attempts = [];
    for (let i = 0; i < categories.length; i++) {
      attempts.push({
        value: categories[i].key + "1",
        label: `${categories[i].title} - ${translate("attempt")} 1`,
      });
      attempts.push({
        value: categories[i].key + "2",
        label: `${categories[i].title} - ${translate("attempt")} 2`,
      });
      attempts.push({
        value: categories[i].key + "3",
        label: `${categories[i].title} - ${translate("attempt")} 3`,
      });
    }

    return attempts;
  }

  return [];
}
